import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiSend = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z" />
  </SvgWrapper>
);
